import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { styled } from '@mui/system';
import { makeStyles } from '@mui/styles';
import { Modal, Fade, Box, Button, Backdrop } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReLazyImage from './ReLazyImage';
import { useStoreSettings } from '@state/useStoreSettings';
import { useStoreAppColor } from '@state/useStoreAppColor';
import theme from '@styles/theme';
// Styled container for the modal content
const ModalContent = styled('div')(({ theme }) => ({
  width: '95%',
  maxWidth: 450,
  padding: theme.spacing(4),
  backgroundColor: 'white',
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
  outline: 'none',
  margin: 'auto',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}));

// Styles for the modal container
const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    zIndex: '1500 !important',
    justifyContent: 'center',
    outline: 'none',
  },
});

const GreetingModal = (_props, ref) => {
  const appColor = useStoreAppColor((state) => state.appColor);
  const classes = useStyles();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [onContinueCallback, setOnContinueCallback] = useState(null);
  const settings = useStoreSettings((state) => state.settings);

  // Expose the "show" method to the parent using ref.
  const show = (onContinue) => {
    setOnContinueCallback(() => onContinue);
    setVisible(true); // Open modal via local state
    return true;
  };

  // When user clicks Continue, close the modal and update Zustand state.
  const handleContinue = () => {
    setVisible(false); // Close modal via local state
    if (onContinueCallback) {
      onContinueCallback();
    }
  };

  useImperativeHandle(ref, () => ({ show }));

  return (
    <Modal
      aria-labelledby="greetings-modal-title"
      aria-describedby="greetings-modal-description"
      open={visible} // Bind local state to modal visibility
      className={classes.modal}>
      <Fade in={visible}>
        <ModalContent>
          {/* Image */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 2,
            }}>
            <ReLazyImage
              url={settings.popupUrl}
              alt="Greetings"
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
              }}
            />
          </Box>
          {/* Continue Button */}
          <Button
            variant="contained"
            onClick={handleContinue}
            sx={{
              marginTop: 2,
              width: '100%',
              color: appColor.secondaryFontColor,
              backgroundColor: appColor.addButton,
              '&:hover': {
                backgroundColor: appColor.addButton,
              },
            }}>
            {t('Continue')}
          </Button>
        </ModalContent>
      </Fade>
    </Modal>
  );
};

export default forwardRef(GreetingModal);
